import {
  FAQS,
  FOOTER_LINKS,
  TERMS_AND_CONDITION,
  PASS_PURCHASE_SUCCESS_MESSAGE,
} from "./helper";
import { routes } from "src/shared/routes";
import { constants } from "src/shared/constants";

import type { TTeamConfig } from "src/shared/types/teamConfig.types";

import OrderSummaryBackgroundImage from "public/images/stpaulsaints/background.png";

const logoImage =
  "https://ss-leagues.s3.amazonaws.com/Minor%20League%20Baseball/St._Paul_Saints.png";

export const stpaulsaints_pass: TTeamConfig = {
  TEAM_SCHEMA: "stpaulsaints_pass",
  TEAM_FULL_NAME: "St. Paul Saints",
  BROWSER_TITLE: "Saints Summer Ballpark Access Pass",
  CLIENT_ID: "RGAMHmBtqCKVj2oyJBA7GrGeXpaJpPmnMEAzXgD9Y20VwYuT",
  VENDOR: constants.vendorUUIDs.ticketsdotcom,

  TEAM_GLOBAL_SETTINGS: {
    COLORS_PRIMARY: "#00539f",
    COLORS_SECONDARY: "#ffffff",
    LOGOUT_ON_INVALID_SESSION: false,
    DEFAULT_APP_ROUTE: routes.landing,
    IS_INTERCOM_ENABLED: true,

    ACCOUNT_MANAGER_URL:
      "https://sp6.glitnirticketing.com/spticket/web/login.php?ret_link=%2Fspticket%2Fweb%2Fwportal.php&type=notLogged",

    NAV_MENU: {
      HIDE_EARN_REWARDS: true,
      HIDE_MANAGE_SUBSCRIPTION: true,
    },

    FOOTER: {
      LINKS: FOOTER_LINKS,
      BACKGROUND_COLOR: "#00539f",
    },
  },

  LANDING_PAGE_SETTINGS: {
    PASS_BANNER: {
      PASS_DISPLAY_MODE: "separate",
      DISABLE_BACKGROUND_IMAGE_FILTER: true,
      IS_FLUID_BACKGROUND_IMAGE_SIZE: true,
    },

    PASS: {
      HIDE_DECIMAL_POINTS_AFTER_PRICE: true,
      SUBSCRIBE_BUTTON_TEXT: "Buy Now!",
    },
  },

  HOME_PAGE_SETTINGS: {
    EVENT_CARD: {
      SHOW_SINGLE_GAMES_IN_COLLAPSE: true,
      ATTEND_BUTTON_COLOR: "#00539f",
    },
  },

  GROUP_INVITE_PAGE_SETTINGS: {
    PASS_BANNER: {
      DISABLE_BACKGROUND_IMAGE_FILTER: true,
      PASS_DISPLAY_MODE: "separate",
    },
  },

  CHECKOUT_PAGE_SETTINGS: {
    CHECKOUT_FORM: {
      SAVE_CARD_SWITCH_ENABLED: false,
      DISABLE_SAVE_CARD: true,
    },
  },

  MANAGE_SUBSCRIPTION_PAGE_SETTINGS: {
    ZERO_STATE: {
      OPT_OUT_EARLIEST_DATE: new Date("10/01/2024"),
    },
  },

  IMAGES: {
    LOGO_URL: logoImage,
    ORDER_SUMMERY_BACKGROUND_URL: OrderSummaryBackgroundImage.src,
  },

  LANGUAGES: {
    FAQS,
    TERMS_AND_CONDITION,
    PASS_PURCHASE_SUCCESS_MESSAGE,
  },
};
